import { render, staticRenderFns } from "./CustomerContactActionsIcons.vue?vue&type=template&id=06347a60&scoped=true&"
import script from "./CustomerContactActionsIcons.vue?vue&type=script&lang=js&"
export * from "./CustomerContactActionsIcons.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContactActionsIcons.vue?vue&type=style&index=0&id=06347a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06347a60",
  null
  
)

export default component.exports